'use strict';

const ritualsStyles = require('./rituals-styles'),
    gtm = require('./modules/google').tagManager;

const GreetingCard = function () {
    function init(updateGiftWrapAndGreetingCardBlockAndPrice) {
        $(document).on('click', '.js-greetingcard-checkbox', toggle);
        $(document).on('click', '.js-greetingcard-cancel', cancel);
        $(document).on('click', '.js-greetingcard-add', addOrUpdateGreetingCard);
        $(document).on('click', '.js-greetingcard-edit', collapseTextArea);
        $(document).on('click', '.js-remove-greetingcard', function (e) {
            e.preventDefault();
            e.stopPropagation();
            clearGreetingCard();
        });

        initCardSelection();
        initTextArea();

        function initCardSelection() {
            $(document).on('click', '.js-gift-wrapping-card-multiple-option', function(){
                selectCard($(this));
            });

            $(document).on('keydown', '.js-gift-wrapping-card-multiple-option', function(e) {
                if (e.which === 32) {
                    e.preventDefault();
                    selectCard($(this));
                }
            });

            $(document).on('cardSelected', '.js-greetingcard-options', function(e, data) {
                pushDataLayerEvent(data.selectedCard);
            });

            onloadSetSelectedCard();
        }

        function pushDataLayerEvent($selectedCard) {
            if (!$selectedCard || !$selectedCard.length) {
                return;
            }
            const $selectedCardName = $selectedCard.find('.js-card-name');
            if (!$selectedCardName.length) {
                return;
            }
            gtm.pushDataLayerEvent({
                event: 'add_card',
                interaction_type: 'click',
                click_target: $selectedCardName.html().toLowerCase() /* eslint-disable-line camelcase */
            });
        }

        function toggle() {
            if ($('.js-greetingcard-edit').length > 0) {
                clearGreetingCard();
                return;
            }

            if ($(this).prop('checked')) {
                $('.js-greetingcard-options').closest('.js-greetingcard').addClass('enabled');
                $('.js-greetingcard-options').show().trigger('cardSelected', [{selectedCard: getSelectedCard()}]);
                //on initial check send placeholder data
                const data = getGreetingCardInfo();
                updateGiftWrapAndGreetingCardBlockAndPrice(data);
                return;
            }

            $('.js-greetingcard-options').closest('.js-greetingcard').removeClass('enabled');
            $('.js-greetingcard-options').hide();
        }

        const getSelectedCard = () => {
            const $greetingCardWrapper = $('.js-greetingcard-select-card');
            if (!$greetingCardWrapper.length) {
                return null;
            }

            return $greetingCardWrapper.find('.selected');
        };

        function collapseTextArea() {
            const $greetingCardCheckbox = $('.js-greetingcard-checkbox');
            if ($greetingCardCheckbox.is(':checked')) {
                $('.js-greetingcard-options').show();
                return;
            }
            $greetingCardCheckbox.prop('checked', true);
            $('.js-greetingcard-options').show();
        }

        function cancel() {
            if ($('.js-greetingcard-edit').length) {
                $('.js-greetingcard-options').hide();
                return;
            }

            $('.js-greetingcard-checkbox').click();
        }

        function selectCard($greetingCardOption) {
            if (!$greetingCardOption.length) {
                return;
            }

            // set radio button
            const greetingCardId = $greetingCardOption.attr('id');
            const greetingCardUrl = $greetingCardOption.find('img').attr('src');
            const $cardOptions = $('.js-gift-wrapping-card-multiple-option');
            $cardOptions.removeClass('selected');

            const $selectedCard = $cardOptions.filter('#' + greetingCardId);
            $selectedCard.addClass('selected').trigger('cardSelected', [{selectedCard: $selectedCard}]);

            // set data attr to be used during greet card ajax request
            const $greetingCardWrapper = $('.js-greetingcard-select-card');
            $greetingCardWrapper.data('selectedcardid', greetingCardId);
            $greetingCardWrapper.data('selectedcardurl', greetingCardUrl);
        }

        function addOrUpdateGreetingCard() {
            const $textarea = $('.js-personal-message-textarea');
            clearGreetingCardError($textarea);
            setDisabledWithSpinner('.js-greetingcard-add', true);
            $.ajax({
                type: 'POST',
                url: Urls.greetingCardAdd,
                data: getGreetingCardInfo(),
                success: function (data) {
                    updateGiftWrapAndGreetingCardBlockAndPrice(data);
                    onloadSetSelectedCard();
                    initLazyLoad();
                    setDisabledWithSpinner('.js-greetingcard-add', false);
                },
                error: function(xhr) {
                    if (xhr.status === 400) {
                        setDisabledWithSpinner('.js-greetingcard-add', false);
                        const response = xhr.responseJSON;
                        if (response.error) {
                            showGreetingCardError($textarea, response.reason);
                            setDisabled('.js-greetingcard-add', true);
                            return;
                        }
                    }
                },
            });
        }

        function clearGreetingCard() {
            $.ajax({
                type: 'POST',
                url: Urls.greetingCardRemove,
                success: function (data) {
                    updateGiftWrapAndGreetingCardBlockAndPrice(data);
                    onloadSetSelectedCard();
                    initLazyLoad();
                }
            });
        }

        function initLazyLoad() {
            if ($('.js-lazy-load').length) {
                ritualsStyles.initLazyLoad();
            }
        }

        function getGreetingCardInfo() {
            const greetingCardInfo = {
                cardText: $('.js-personal-message-textarea').val() === '\n' ? $('.js-personal-message-textarea').val('') : $('.js-personal-message-textarea').val(),
                cardId: '',
                cardImgUrl: ''
            };

            const $giftWrappingCard = $('.js-greetingcard-select-card');

            if (!$giftWrappingCard.length) {
                return greetingCardInfo;
            }

            greetingCardInfo.cardId = $giftWrappingCard.data('selectedcardid');
            greetingCardInfo.cardImgUrl = $giftWrappingCard.data('selectedcardurl');

            return greetingCardInfo;
        }
    }

    function onloadSetSelectedCard() {
        const $greetingCardWrapper = $('.js-greetingcard-select-card');

        if (!$greetingCardWrapper.length) {
            return;
        }

        const $cardOptions = $('.js-gift-wrapping-card-multiple-option');
        if (!$cardOptions.length) {
            return;
        }

        const selectedCardId = $greetingCardWrapper.data('selectedcardid');

        const $selectedCard = typeof selectedCardId !== 'undefined' && selectedCardId ?
            $cardOptions.filter('#' + selectedCardId) : $cardOptions.first();

        $selectedCard.addClass('selected');
        $greetingCardWrapper.data('selectedcardid', $selectedCard.attr('id'));
        $greetingCardWrapper.data('selectedcardurl', $selectedCard.find('img').attr('src') || $selectedCard.find('img').data('src'));
    }

    function initTextArea() {
        const textAreaSelector = '.js-personal-message-textarea';
        $(document).on('scroll', textAreaSelector, function () {
            const linesOffset = $(this).scrollTop();
            $('.js-textarea-lines').css('margin-top', '-' + linesOffset + 'px');
        });

        $(document).on('keypress paste', textAreaSelector, function () {
            limitGiftWrapTextLines(this, $(this).val());
        });

        $(document).on('blur', textAreaSelector, function () {
            validateGreetingCardText();
        });

        $(document).on('keyup paste', textAreaSelector, function () {
            const $this = $(this);
            if (stringMayHaveEmoji($this.val())) {
                validateGreetingCardText();
                return;
            }

            clearGreetingCardError($this);
            setDisabled('.js-greetingcard-add', false);
        });

        $(document).on('input paste', textAreaSelector, function () {
            const $msg = $(this);
            const maxLength = $msg.attr('maxlength');
            const currentLength = $msg.val().length;
            const charLeft = maxLength - currentLength;

            $('.js-char-left').html(charLeft);
        });
    }

    function validateGreetingCardText() {
        const $textarea = $('.js-personal-message-textarea');
        $.ajax({
            url: Urls.validateGreetingCardText,
            type: 'POST',
            data: {greetingCardText: $textarea.val()},
            success: function (response) {
                clearGreetingCardError($textarea);
                if (response.error) {
                    showGreetingCardError($textarea, response.reason);
                    setDisabled('.js-greetingcard-add', true);
                    return;
                }

                setDisabled('.js-greetingcard-add', false);
            }
        });
    }

    function stringMayHaveEmoji(str) {
        const lowestPossibleEmojiChar = '\ud800';

        for (const idx in str) {
            const char = str[idx];
            if (char >= lowestPossibleEmojiChar) {
                return true;
            }
        }

        return false;
    }

    function limitGiftWrapTextLines(textAreaElement, oldText) {
        // Wait until the character is actually inserted
        setTimeout(function () {
            // If entering this text made the textarea scroll further down, cancel that text
            if (textAreaElement.scrollHeight - textAreaElement.clientHeight > 1) { // 1px because on the 5th line there's already a scroll bar, and there's a 1px difference
                $(textAreaElement).val(oldText);
            }
        }, 1);
    }

    function showGreetingCardError($textarea, error) {
        $textarea.removeClass('error').parent().parent().find('span.error').remove();
        $textarea.removeClass('valid').addClass('error').parent().before(
            $('<span/>').addClass('error').text(error)
        );
    }

    function clearGreetingCardError($textarea) {
        $textarea.removeClass('error').parent().parent().find('span.error').remove();
    }

    function setDisabledWithSpinner(buttonSelector, disabled) {
        const button = $(buttonSelector);
        if (!button.length) {
            return;
        }

        if (disabled) {
            button.addClass('btn--disabled').addClass('button-loading');
            button.find('.js-spinner-general').addClass('spinner-visible');
            return;
        }

        button.removeClass('btn--disabled').removeClass('button-loading');
        button.find('.js-spinner-general').removeClass('spinner-visible');
    }

    function setDisabled(classSelector, isDisabled) {
        $(classSelector).prop('disabled', isDisabled);
    }

    return {
        init: init,
        onloadSetSelectedCard: onloadSetSelectedCard
    };
};

module.exports = new GreetingCard();
